import { fromJS } from 'immutable';

import { START, SUCCESS, ERROR, FORM_SHOW, FORM_HIDE } from '../../consts';
import { ANNOUNCEMENT_LOAD, PRICE_SUBSCRIPTION } from './actionTypes';

import api from '../../apiSingleton';

export function fetchAnnouncement (param) {
  const announcementId = fromJS(param).getIn(['location', 'params', 'id'], 0);

  return (dispatch, getState) => {
    const state = getState();
    const section = state.get('section');
    const dealType = section.get('dealType');
    const realtyType = section.get('realtyType');

    const filter = {
      regionId: state.getIn(['domain', 'regionId'], 55),
      localityId: state.getIn(['domain', 'localityId'], null),
      token: state.getIn(['user', 'token'], '')
    };

    return dispatch(loadAnnouncement(dealType, realtyType, announcementId, filter));
  };
}

export function loadAnnouncement (dealType, realtyType, announcementId, filter) {
  return dispatch => {
    dispatch({
      type: ANNOUNCEMENT_LOAD + START
    });

    return api.announcement.fetchAnnouncementItem(dealType, realtyType, announcementId, filter)
        .then((data) => dispatch({
          type: ANNOUNCEMENT_LOAD + SUCCESS,
          item: fromJS(data) || null,
          meta: fromJS(data._meta || {})
        }))
        .catch((err) => dispatch({
          type: ANNOUNCEMENT_LOAD + ERROR,
          payload: err.message
        }));
  };
}

/**
 * Отобразить форму - подписаться на историю изменения цены
 * data {
 *    realtyId: number,
 *    dealType: string,
 *    realtyType: string,
 * }
 * @param data
 * @returns {{type: *, payload: *}}
 */
export function showPriceSubscriptionForm (data) {
  return {
    type: PRICE_SUBSCRIPTION + FORM_SHOW,
    payload: data
  };
}

export function hidePriceSubscriptionForm () {
  return {
    type: PRICE_SUBSCRIPTION + FORM_HIDE
  };
}

/**
 * Сохранить подписку на изменение цены
 * @param data
 * @returns {function(*)}
 */
export function savePriceSubscriptionForm (data) {
  return dispatch => {
    dispatch({
      type: PRICE_SUBSCRIPTION + START
    });

    return api.announcement.priceSubscription(data)
      .then((data) => dispatch({
        type: PRICE_SUBSCRIPTION + SUCCESS
      }))
      .catch((err) => {
        return dispatch({
          type: PRICE_SUBSCRIPTION + ERROR,
          payload: err.messages
        });
      });
  };
}



// WEBPACK FOOTER //
// ./src/app/CardAnnouncement/actions.js